module.exports = __webpack_public_path__ + "img/chevron-up.9a25a663.svg";